<template>
    <div class="main">
      <div
        class="dropzone-container"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
      >
        <input
          type="file"
          name="file"
          id="fileInput"
          class="hidden-input"
          @change="onChange"
          ref="file"
          accept=".pdf,.jpg,.jpeg,.png"
        />
        <div v-if="processing">Uploading: <u> {{ percentage }} %</u></div>
        <span ref="progress" class="file-progress has-file-progress"><span ref="progressbar" class="file-progress-bar" style="width: 77%;"></span></span>
        <div ref="progresstext"></div>
        
        <label for="fileInput" class="file-label" v-if="!processing">
          <div v-if="isDragging">Release to drop files here.</div>
          <div v-else>Drop files here or <u>click here</u> to upload.</div>
          
        </label>
  
        <div class="preview-container mt-4" v-if="files.length">
          <div v-for="file in files" :key="file.name" class="preview-card">
            <div>
              <img class="preview-img" :src="generateThumbnail(file)" />
              <p :title="file.name">
                {{ makeName(file.name) }}
              </p>
            </div>
            <div>
              <button
                class="ml-2"
                type="button"
                @click="remove(files.indexOf(file))"
                title="Remove file"
              >
                <b>&times;</b>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
import * as Tus from 'tus-js-client'
import Swal from 'sweetalert2'

export default {
    data() {
      return {
        isDragging: false,
        files: [],
        processing: false,
        percentage: '',
      };
    },
    props: {
      pbid: '',  
    },
    methods: {

      dzUrl(){
            return process.env.VUE_APP_API_HOST + '/files/';
        },


      removeFile(index) {
      // If the file is currently uploading, abort it
      if (this.currentUpload && this.currentUpload.file === this.files[index]) {
        this.currentUpload.abort();
      }
      this.files.splice(index, 1);
    },
      showError(message) {
        Swal.fire({
          title: 'Error',
          text: message,
          icon: 'error',
          confirmButtonText: 'OK'
        });
        this.loading = false;
        this.$emit('uploading', false);
      },

      onChange() {
        console.log("OnChange: "+this.pbid);
        this.files = [...this.$refs.file.files];
        console.log(this.$refs.file.files);
        console.log(this.$refs.file.files[0]);
        console.log(this.$refs.file.files.first);
        let name = this.doTheUpload(this.$refs.file.files[0]).then(function () {
          console.log("inside the then call");
        })
        console.log("name is -> "+name);
        /*
        this.doTheUpload(this.$refs.file.files[0]).then((response) => {
                console.log("fetched design example pics and the upload should be done");
                console.log(response);
               // this.design_example_images = response.data.photo_book_images;
               // console.log(this.design_example_images.length);
              //  if(this.design_example_images.length > 0){
              //      this.upload_design_examples = true;
              //  }
            }).catch((e) => {
                console.log(e);
            }).finally(() => {
                this.loading = false;
                console.log("finished loading the file to railsp");
            });;
            */
      },

      async pingServer(reg){
            this.loading = true;
            this.$api.addTusPhotoBookImage(this.currentPhotoBook.id, reg).then((response) => {
                console.log("fetched design example pics");
                console.log(response);
               // this.design_example_images = response.data.photo_book_images;
               // console.log(this.design_example_images.length);
              //  if(this.design_example_images.length > 0){
              //      this.upload_design_examples = true;
              //  }
            }).catch((e) => {
                console.log(e);
            }).finally(() => {
                this.loading = false;
            });
        },


       async doTheUpload(file){
        this.processing = true;
        this.$emit('uploading', true);
        // Get the selected file from the input element
        //var file = e.target.files[0]
        const fileIndex = this.files.indexOf(file);
        // Create a new tus upload
        var upload = new Tus.Upload(file, {
          endpoint: this.dzUrl(), //'http://0.0.0.0:8000/files/',
          retryDelays: [0, 3000, 5000, 10000, 20000],
          metadata: {
            filename: file.name,
            filetype: file.type,
          },
          onError: (error) => {
            console.log('Failed because: ' + error);
            this.showError(`Upload failed: ${error}`);
            this.removeFile(fileIndex);
            this.$emit('uploading', false);
          },
          onProgress: (bytesUploaded, bytesTotal) => {
            var percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
            this.percentage = percentage;
            console.log(bytesUploaded, bytesTotal, percentage + '%');
          },
          onSuccess: async () => {
            console.log('Upload completed:', upload.url);
            


            try {
              const addr = `${process.env.VUE_APP_API_HOST}/api/v1/spa/photo_books/${this.pbid}/add_photo_book_image_tus`;
              const response = await fetch(addr, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                   'Authorization': 'Bearer ' + localStorage.token
                },
                body: JSON.stringify({
                  id: this.pbid,
                  photo_book: {
                    photo_book_images: {
                      temp_image: upload.url.split('/').slice(-1)[0],
                      filetype: upload.file.name.split('.').slice(-1)[0],
                      imagetype: 'interior',
                    }
                  }
                })
              });

              const data = await response.json();
              
              if (data.errors) {
                // Handle Rails error messages
                if (data.errors) {
                  const errorMessage = Array.isArray(data.errors) 
                    ? data.errors.join('\n') 
                    : Object.entries(data.errors).map(([key, value]) => `${key}: ${value}`).join('\n');
                  this.showError(errorMessage);

                  this.removeFile(fileIndex);
                 // this.processing = false;

                } else {
                  throw new Error('Network response was not ok');
                }
                return;
              }

              console.log('Server response:', data);
              this.$emit('upload-complete', data);
              this.$emit('uploading', false);
            //  this.processing = false;
              this.files = [];
              this.$emit('photoBookImageUploaded', data);

              return data;
            } catch (error) {
              console.error('Error sending file info to server:', error);
              this.showError(`Error processing upload: ${error.message}`);
              throw error;
            }
          }
        });

        try {
          const previousUploads = await upload.findPreviousUploads();
          if (previousUploads.length) {
            upload.resumeFromPreviousUpload(previousUploads[0]);
          }
          upload.start();
        } catch (error) {
          console.error('Error starting upload:', error);
          this.showError(`Error starting upload: ${error.message}`);
        }
        this.$emit('uploading', false);
       // this.processing = false;
       setTimeout(() => this.processing = false, 2000);
        this.files = [];
        return upload;
      },
  


      generateThumbnail(file) {
        let fileSrc = URL.createObjectURL(file);
        setTimeout(() => {
          URL.revokeObjectURL(fileSrc);
        }, 1000);
        return fileSrc;
      },
  
      makeName(name) {
        return (
          name.split(".")[0].substring(0, 3) +
          "..." +
          name.split(".")[name.split(".").length - 1]
        );
      },
  
      remove(i) {
        this.files.splice(i, 1);
      },
  
      dragover(e) {
        e.preventDefault();
        this.isDragging = true;
      },
  
      dragleave() {
        this.isDragging = false;
      },
  
      drop(e) {
        e.preventDefault();
        this.$refs.file.files = e.dataTransfer.files;
        this.onChange();
        this.isDragging = false;
      },
    },
    mounted() {
        console.log("DropFile: "+this.pbid);
    },
  };
  </script>
  
  <style>
  .maino {
    display: flex;
    flex-grow: 1;
    align-items: center;
    height: 100vh;
    justify-content: center;
    text-align: center;
  }
    .main {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  
  .dropzone-container {
    padding: 4rem;
    background: #f7fafc;
    border: 1px solid #e2e8f0;

    width: 100% !important;
  height: 100% !important;



  }
  .hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
  }
  .file-label {
    font-size: 20px;
    display: block;
    cursor: pointer;
  }
  .preview-container {
    display: flex;
    margin-top: 2rem;
  }
  .preview-card {
    display: flex;
    border: 1px solid #a2a2a2;
    padding: 5px;
    margin-left: 5px;
  }
  .preview-img {
    width: 50px;
    height: 50px;
    border-radius: 5px;
    border: 1px solid #a2a2a2;
    background-color: #a2a2a2;
  }
  </style>